export const PLAYER_TYPES = {
	all: 'ALL',
	atv: 'ATV',
	box: 'BOX',
	mobile: 'MOBILE',
	web: 'WEB'
};
